// extracted by mini-css-extract-plugin
export default {"navbar":"Navigation_navbar__+f-dY","navlinks":"Navigation_navlinks__erBNv"};